module.exports = __webpack_public_path__ + "img/quiz_mungjju_happy.e0fe6c72.png";